module.exports = __webpack_public_path__ + "img/zhor1.ef76edf9.jpg";